import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GoogleMapsService {

	constructor() { }

	
	constructor_autocomplete(input:HTMLInputElement, callback:()=>void) : google.maps.places.Autocomplete {
		let autocomplete = new google.maps.places.Autocomplete(
			input,
			{
				componentRestrictions: { country: "AR" }, // set the country restriction
			}
		);

		google.maps.event.addListener(autocomplete, 'place_changed', callback);

		return autocomplete;
	}
	constructor_map(mapDiv:HTMLDivElement) : google.maps.Map {
		let map = new google.maps.Map(mapDiv,
			{
				zoom: 11,
				streetViewControl: false,
				controlSize: 30,
				mapTypeControl: false,
				keyboardShortcuts: false,
				maxZoom: 17,
				minZoom: 5,
				scrollwheel: false,
				styles: [
					// Base
					{
						featureType: "road.highway",
						elementType: "geometry.fill",
						stylers: [{color: "#ddcfed"}]
					},
					{
						featureType: "road.highway",
						elementType: "geometry.stroke",
						stylers: [{color: "#cfbde0"}]
					},
					{
						featureType: "road.highway",
						elementType: "labels.text.fill",
						stylers: [{color: "#63469c"}]
					},
					{
						featureType: "administrative",
						elementType: "labels.text.fill",
						stylers: [{color: "#736a7b"}]
					},
					{
						featureType: "landscape",
						elementType: "geometry.fill",
						stylers: [{color: "#edebef"}]
					},
					{
						featureType: "landscape",
						elementType: "geometry.stroke",
						stylers: [{color: "#ccc0ce"}]
					},
					{
						featureType: "road.local",
						elementType: "geometry.fill",
						stylers: [{color: "#ffffff"}]
					},
					{
						featureType: "road.local",
						elementType: "labels.text.fill",
						stylers: [{color: "#736a7b"}]
					},
					{
						featureType: "road.arterial",
						elementType: "labels.text.fill",
						stylers: [{color: "#736a7b"}]
					},
					{
						featureType: "water",
						elementType: "all",
						stylers: [{color: "#9cc3fc"}]
					},
					{
						featureType: "transit",
						elementType: "geometry.fill",
						stylers: [{color: "#cfcbd2"}]
					},
					{
						featureType: "transit",
						elementType: "labels.icon",
						stylers: [{color: "#267DFF"}]
					},
					{
						featureType: "transit.station.airport",
						elementType: "geometry.fill",
						stylers: [{color: "#edebef"}]
					},
					{
						featureType: "transit.station.airport",
						elementType: "geometry.stroke",
						stylers: [{color: "#ccc0ce"}]
					},

					// Parque (base $color_success)
					{
						featureType: "poi.park",
						elementType: "geometry.fill",
						stylers: [{color: "#b0e3b0"}]
					},
					{
						featureType: "poi.park",
						elementType: "labels.icon",
						stylers: [{color: "#2a8f16"}]
					},
					{
						featureType: "poi.park",
						elementType: "labels.text.fill",
						stylers: [{color: "#2a8f16"}]
					},

					// Canchas y polideportivos	(base $color_success)
					{
						featureType: "poi.sports_complex",
						elementType: "geometry.fill",
						stylers: [{color: "#b0e3b0"}]
					},
					{
						featureType: "poi.sports_complex",
						elementType: "labels.icon",
						stylers: [{color: "#2a8f16"}]
					},
					{
						featureType: "poi.sports_complex",
						elementType: "labels.text.fill",
						stylers: [{color: "#2a8f16"}]
					},

					// Hospitales (base $color_error)
					{
						featureType: "poi.medical",
						elementType: "geometry.fill",
						stylers: [{color: "#ffebe5"}]
					},
					{
						featureType: "poi.medical",
						elementType: "labels.icon",
						stylers: [{color: "#f68550"}]
					},
					{
						featureType: "poi.medical",
						elementType: "labels.text.fill",
						stylers: [{color: "#f68550"}]
					},

					// Negocios	y puntos turísticos (base color_primary_500, excepto terreno basado en $color_success)
					{
						featureType: "poi.business",
						elementType: "geometry.fill",
						stylers: [{color: "#b0e3b0"}]
					},
					{
						featureType: "poi.business",
						elementType: "labels.icon",
						stylers: [{color: "#c695f2"}]
					},
					{
						featureType: "poi.business",
						elementType: "labels.text.fill",
						stylers: [{color: "#c695f2"}]
					},
					{
						featureType: "poi.attraction",
						elementType: "labels.icon",
						stylers: [{color: "#c695f2"}]
					},
					{
						featureType: "poi.attraction",
						elementType: "labels.text.fill",
						stylers: [{color: "#c695f2"}]
					},

					// Estatales, escuelas, iglesias
					{
						featureType: "poi.government",
						elementType: "labels.icon",
						stylers: [{color: "#8a8193"}]
					},
					{
						featureType: "poi.government",
						elementType: "labels.text.fill",
						stylers: [{color: "#8a8193"}]
					},
					{
						featureType: "poi.place_of_worship",
						elementType: "labels.icon",
						stylers: [{color: "#8a8193"}]
					},
					{
						featureType: "poi.place_of_worship",
						elementType: "labels.text.fill",
						stylers: [{color: "#8a8193"}]
					},
					{
						featureType: "poi.school",
						elementType: "labels.icon",
						stylers: [{color: "#8a8193"}]
					},
					{
						featureType: "poi.school",
						elementType: "labels.text.fill",
						stylers: [{color: "#8a8193"}]
					},
				]
			}
		);

		// En el centro de capital, Caballito
		let initialCoordinates = { lat: -34.612936, lng: -58.443505 };
		
		map.setCenter(initialCoordinates);
		return map;
	}
	
	showPlaceOnMap(map:google.maps.Map, place:google.maps.places.PlaceResult, marker:google.maps.Marker) {
		marker.setPosition(place.geometry!.location);
		marker.setLabel({
			text: place.name,
			className: "google_maps_marker_label",
		});
		map.setCenter(place.geometry!.location);
		map.setZoom(15);
	}
}
